import React from 'react';
import { IconProps } from '@/models/IconProps';

const ArrowDown: React.FC<IconProps> = ({ strokeColor = '#4A4D4E' }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="13" height="7" viewBox="0 0 13 7" fill="none">
    <path d="M12.5 0.5L6.5 6.5L0.499999 0.500001" stroke={strokeColor} strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export default ArrowDown;
